import React, { useState } from "react";
import { useMoralis, useNFTBalances } from "react-moralis";
import { Card, Image, Tooltip, Modal, Button, Skeleton } from "antd";
import {
  FileSearchOutlined,
  EditOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { getExplorer } from "helpers/networks";
import AddressInput from "./AddressInput";
import { useVerifyMetadata } from "hooks/useVerifyMetadata";
import Draw from "./NFTDraw";
const { Meta } = Card;

const styles = {
  NFTs: {
    display: "flex",
    flexWrap: "wrap",
    WebkitBoxPack: "start",
    justifyContent: "flex-start",
    margin: "0 auto",
    maxWidth: "1100px",
    width: "100%",
    gap: "20px",
  },
  titlebox: {
    background:
      "linear-gradient(222deg, rgb(31, 32, 48) 0%, rgba(26,27,38,1) 31%, rgb(30, 32, 44) 54%, rgba(26,26,37,1) 100%)",
    border: "0px",
    borderRadius: "5px",
    padding: "15px",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
    marginTop: "-55px",
    marginBottom: "35px",
  },
  titlebox2: {
    background:
      "linear-gradient(222deg, rgb(31, 32, 48) 0%, rgba(26,27,38,1) 31%, rgb(30, 32, 44) 54%, rgba(26,26,37,1) 100%)",
    border: "0px",
    borderRadius: "5px",
    padding: "15px",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
    marginTop: "55px",
    marginBottom: "15px",
  },
  titles: {
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
    fontSize: "16px",
  },
};

function NFTMint() {
  const { data: NFTBalances } = useNFTBalances();
  const { Moralis, chainId } = useMoralis();
  const [visible, setVisibility] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const { verifyMetadata } = useVerifyMetadata();

  function reload() {
    if (window.localStorage) {
      if (!localStorage.getItem("firstLoad")) {
        localStorage["firstLoad"] = true;
        window.location.reload();
      } else localStorage.removeItem("firstLoad");
    }
  }
  //console.log("NFTBalances", NFTBalances);
  return (
    <div
      style={{
        padding: "15px",
        maxWidth: "1050px",
        width: "100%",
        height: "webkit-fill-available",
      }}
    >
      <div style={styles.titlebox}>
        <h1 style={styles.titles}>
          Here you can view unlocked content by the NFTs you own{" "}
        </h1>
      </div>

      <div style={styles.NFTs}>
        <Skeleton loading={!NFTBalances?.result}>
          {NFTBalances?.result &&
            NFTBalances.result.map((nft, index) => {
              //Verify Metadata
              console.log(nft.metadata, "metadata");
              nft = verifyMetadata(nft);
              const tokenId = nft.token_id;
              const tokenAddress = nft.token_address;
              const myNft = 0xbc21a56754330d40112115241fd2fa551faac1e9;
              //const tokenName = nft.name
              const drawTheData = async () => {
                setVisibility(true);
                console.log(tokenId, "id");
                localStorage.setItem("StoredIDtoken", tokenId);

                //external constants
                const MonsterCreature = Moralis.Object.extend("Monster");
                const monster = new MonsterCreature();

                const queryId = new Moralis.Query("Monster");
                queryId.equalTo("tokenId", tokenId);
                const resultsId = await queryId.find();
                console.log(resultsId, "console log results ID query");

                for (let i = 0; i < resultsId.length; i++) {
                  const object = resultsId[i];
                  console.log(object.get("tokenId"), "storedTokenId - db)");

                  if (resultsId.length > 0) {
                    resultsId[0].set("tokenId", tokenId);
                    resultsId[0].save();
                  } else {
                    monster.set("tokenId", tokenId); // TOKEN ID
                    await monster.save();
                  }
                }
              };

              ////  NFT TOKEN ADDRESS = 0x378fcD07289fe56ae56F7d21e2bD5634Ed3C5C6D//
              if (tokenAddress == myNft)
                return (
                  <div>
                    <Card
                      hoverable
                      actions={[
                        <Tooltip title="View On Blockexplorer">
                          <FileSearchOutlined
                            onClick={() =>
                              window.open(
                                `${getExplorer(chainId)}address/${
                                  nft.token_address
                                }`,
                                "_blank",
                              )
                            }
                          />
                        </Tooltip>,
                        <Tooltip title="Edit NFT Private File">
                          <EditOutlined onClick={() => drawTheData()} />
                        </Tooltip>,
                      ]}
                      style={{
                        background:
                          "linear-gradient(222deg, rgb(31, 32, 48) 0%, rgba(26,27,38,1) 31%, rgb(30, 32, 44) 54%, rgba(26,26,37,1) 100%)",
                        width: "240px",
                        border: "0px",
                        borderRadius: "5px",
                        padding: "15px",
                        boxShadow:
                          "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
                        margin: "0px",
                        height: "webkit-fill-available",
                      }}
                      key={index}
                    >
                      <Meta
                        style={{ textAlign: "center" }}
                        title={nft.token_id}
                      />
                      <Meta style={{ textAlign: "center" }} title={nft.name} />
                    </Card>
                    <div></div>
                  </div>
                );
            })}
        </Skeleton>
      </div>

      <Modal
        visible={visible}
        onCancel={() => reload()}
        onOk={() => reload()}
        confirmLoading={isPending}
        okText="Finish"
        width={1000}
        afterClose={() => reload()}
        closable={true}
        footer={[
          <Button key="back" onClick={() => reload()}>
            Close
          </Button>,
        ]}
      >
        <Draw />
      </Modal>
      <div
        style={{ marginBottom: "25px", height: "webkit-fill-available" }}
      ></div>
    </div>
  );
}
//
export default NFTMint;
